<a (click)="onToggle()" class="toggle" [ngClass]="{'toggled': toggled }"><span>{{ toggleTitle }}</span> <img src="../../assets/svgs/chevron_forward_blue.svg" class="ml-1" /></a>
<div class="content" [ngClass]="{'toggled': toggled }">
  <ng-content></ng-content>
</div>
